// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e6522de6","732":"c3c6d350"}[chunkId] + ".chunk.js";
};